import { CodesMDC } from '../../FrontApplet/NativeCommands/MDC/CodesMDC';
import { IMDCResponse } from '../../FrontApplet/NativeCommands/MDC/Mdc';

export type ManagementNativeCommandsMdcRequests = ManagementNativeCommandsMdcSendOneRequest;

export const ManagementNativeCommandsMdcSendOneRequest = 'sos.Monitoring.ManagementNativeCommandsMdcSendOneRequest';
export interface ManagementNativeCommandsMdcSendOneRequest {
	type: typeof ManagementNativeCommandsMdcSendOneRequest;
	ipAddress: string;
	codes: CodesMDC;
	data?: number[] | [];
}

export const ManagementNativeCommandsMdcSendOneResult = 'sos.Monitoring.ManagementNativeCommandsMdcSendOneResult';
export interface ManagementNativeCommandsMdcSendOneResult {
	type: typeof ManagementNativeCommandsMdcSendOneResult;
	result: IMDCResponse;
}
